module.exports = __webpack_public_path__ + "static/media/4.014fd695.png";